export function handleRequest(retailRequest, variantName, pricePromise) {
  if (retailRequest) {
    const priceApiPromises = [pricePromise(retailRequest)]

    if (variantName === 'EXPRESS') {
      const expressOWRequest = { ...retailRequest, sopq: true }
      priceApiPromises.push(pricePromise(expressOWRequest))
    }

    return Promise.all(priceApiPromises)
  }

  return Promise.resolve(null)
}
